import {
  ErrorOutlineIcon,
  Flex,
  mergeSx,
  Text,
  type FlexProps,
  type SvgIconProps,
  type TextProps,
} from '@shared/components';

export interface FormErrorTextProps extends FlexProps {
  slotProps?: {
    text?: TextProps;
    icon?: SvgIconProps;
  };
}

export default function FormErrorText(props: Readonly<FormErrorTextProps>) {
  const { slotProps = {}, children, sx, ...restProps } = props;
  const { text: { variant, ...textProps } = {}, icon: iconProps } = slotProps;

  if (!children) {
    return null;
  }

  return (
    <Flex
      {...restProps}
      sx={mergeSx(
        (theme) => ({ color: 'error.main', gap: theme.spacing(1), alignItems: 'center' }),
        sx,
      )}
    >
      <ErrorOutlineIcon {...iconProps} />
      <Text {...textProps} variant={variant ?? 'body2'}>
        {children}
      </Text>
    </Flex>
  );
}
